///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Toolbar } from 'ngx-editor';

export interface NoteItem {
    readonly DIALOG_TITLE_TRANSLATION_PATH: string;
    fieldList: any[];
    getPlainObject(): any;
}

export const defaultToolbarRules: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify']
];
